import { useState, useEffect } from 'react'

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Cookie同意状態をチェック
    const consent = localStorage.getItem('cookie-consent')
    if (!consent) {
      setShowBanner(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted')
    localStorage.setItem('cookie-consent-date', new Date().toISOString())
    setShowBanner(false)
    
    // Google AnalyticsやAdSenseの初期化をここで実行
    if ((window as any).gtag) {
      (window as any).gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted'
      })
    }
  }

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined')
    localStorage.setItem('cookie-consent-date', new Date().toISOString())
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>🍪 Cookieの使用について</h3>
          <p>
            当サイトでは、サイトの改善や適切な広告の表示のためにCookieを使用しています。
            継続して閲覧することでCookieの使用に同意したことになります。
            <a href="/privacy" className="cookie-link">プライバシーポリシー</a>で詳細をご確認ください。
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button className="btn btn-secondary btn-sm" onClick={handleDecline}>
            拒否
          </button>
          <button className="btn btn-primary btn-sm" onClick={handleAccept}>
            同意する
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent